angular.module('impactx.MenuDirectives').controller('CustomerServiceInfoCtrl', ['$scope', '$context', '$mdDialog', 'TranslationService', CustomerServiceInfoCtrl]);

function CustomerServiceInfoCtrl($scope, $context, $mdDialog, TranslationService)
{
    var self = this;
    this.context = $context;
    this.translationService = TranslationService;

    this.openInfoDialog = function(ev) {
        $mdDialog.hide();
        $mdDialog.show({
            controller: 'SimpleDialogCtrl',
            controllerAs: 'simpleDialogCtrl',
            templateUrl: 'shared/user/templates/usercontact.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: false,
            locals: {
                userData: $context.customerServiceUser.value,
                buttonFunction: undefined,
                buttonTranslation: undefined
            }
        });
    };
}